export function averageRating(ratings: Record<string, number>): number {
  const vals = Object.values(ratings).filter(Boolean);
  if (!vals.length) return 0;
  return vals.reduce((a, b) => a + b, 0) / vals.length;
}
